// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__sfTpi","expandIcon":"styles_expandIcon__PbJYO","open":"styles_open__atu6g","collapse":"styles_collapse__opLvZ","content":"styles_content__Z3RvN"};